import { useNavigate } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useSbAuth } from "@/context/SupabaseAuthContext";
import { PageHeader } from "@/components/library/layout";
import { Pill } from "@/components/shared/ui";
import Icon from "@/components/Icon";
import { useStore, DEPARTMENTS, list, OWNER_ONLY_SLUGS, lagerSummary } from "@/lib/dataStore";

export default function Operation() {
  useStore();
  const { currentRestaurant, currentMembership, hasPermission } = useSbAuth();
  const nav = useNavigate();
  const rid = currentRestaurant?.id;
  const myDept = currentMembership?.department;
  const depts = (myDept ? DEPARTMENTS.filter((d) => d.slug === myDept || d.slug === "kunskap") : DEPARTMENTS)
    .filter((d) => !OWNER_ONLY_SLUGS.includes(d.slug) || hasPermission("foodcost.access"));

  const deptStats = (slug) => {
    const open = list(rid, "incidents").filter((i) => i.department === slug && i.status !== "closed" && i.status !== "resolved").length;
    const cls = list(rid, "checklists").filter((c) => c.department === slug).length;
    return { open, cls };
  };

  return (
    <div className="max-w-[1100px] mx-auto p-6 sm:p-10 animate-fade-up" data-testid="operation-page">
      <PageHeader title="Avdelningar" description="Den dagliga driften per avdelning. Välj en avdelning för checklistor, uppgifter, problem och historik." />
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {depts.map((d) => {
          const st = deptStats(d.slug);
          return (
            <button key={d.slug} onClick={() => nav(d.slug === "foodcost" ? "/konto/foodcost" : `/konto/operation/${d.slug}`)} data-testid={`operation-dept-${d.slug}`}
              className="group text-left bg-card border border-border rounded-2xl p-5 hover:border-[hsl(var(--border-hover))] hover:-translate-y-0.5 transition-all duration-300">
              <div className="flex items-start justify-between">
                <span className="h-11 w-11 grid place-items-center rounded-xl text-white" style={{ background: d.color }}><Icon name={d.icon} className="h-5 w-5" strokeWidth={2} /></span>
                <ArrowUpRight className="h-4 w-4 text-muted-foreground group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all" />
              </div>
              <h3 className="font-display font-bold text-lg mt-4 tracking-tight">{d.name}</h3>
              <p className="text-sm text-muted-foreground mt-1 line-clamp-2">{d.description}</p>
              <div className="flex items-center gap-2 mt-4">
                {d.slug === "lager" ? (
                  (() => { const up = lagerSummary(rid).underPar; return up > 0
                    ? <Pill tone="danger">{up} under par-nivå</Pill>
                    : <Pill tone="success">Lagernivåer OK</Pill>; })()
                ) : (
                  <>
                    {st.open > 0 ? <Pill tone="danger">{st.open} problem</Pill> : <Pill tone="success">Inga problem</Pill>}
                    <Pill>{st.cls} checklistor</Pill>
                  </>
                )}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
